
import classes from './Copyright.module.scss';

const Copyright = (props) =>{
    return(
        <div className={classes.copyright}>{`© 2021 ${props.company.name}`}</div>
    );
};

export default Copyright;